// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__U9OA5","header":"ReportDetails_header__1d4h1","title":"ReportDetails_title__35oUI","left":"ReportDetails_left__2ywes"};